export default __webpack_public_path__ + "static/2024_2025_WVS INDIA CONSOLIDATED ACCOUNTS-97ec45d6ed3fe56f6fa8e99dd04553c2.pdf";